import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function sortableListReducer(state = initialState.sortableList, action) {
    switch (action.type) {
        case types.UPDATE_SORTABLE_LIST_SUCCESS:
            state = {...state};
            state[action.listId] = {
                column: action.column,
                asc: action.asc,
                search: action.search,
                withDeleted: action.withDeleted,
                portalId: action.portalId,
                subscriptionType: action.subscriptionType
            };

            return state;
        case types.RESET_SORTABLE_LIST_SUCCESS:
            if(state[action.listId]) {
                state = {...state};
                state[action.listId] = null;
            }

            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/sortableListReducer.js